import {MatPaginatorIntl} from '@angular/material/paginator';
import {TranslateService} from '@ngx-translate/core';

export class PaginatorI18n {
  paginatorIntl: MatPaginatorIntl;

  constructor(private readonly translate: TranslateService) {}

  getPaginatorIntl(): MatPaginatorIntl {
    this.paginatorIntl = new MatPaginatorIntl();
    this.translate
      .get([
        'paginatorIntl.items_per_page',
        'paginatorIntl.next_page',
        'paginatorIntl.previous_page',
        'paginatorIntl.first_page',
        'paginatorIntl.last_page',
        'paginatorIntl.range_1',
        'paginatorIntl.range_2'
      ])
      .subscribe(() => {
        this.translateLabels();
      });

    this.translate.onLangChange.subscribe(() => {
      this.translateLabels();
    });

    return this.paginatorIntl;
  }

  private getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0 || pageSize === 0) {
      return this.translate.instant('paginatorIntl.range_1', {length});
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return this.translate.instant('paginatorIntl.range_2', {startIndex: startIndex + 1, endIndex, length});
  }

  translateLabels() {
    this.paginatorIntl.itemsPerPageLabel = this.translate.instant('paginatorIntl.items_per_page');
    this.paginatorIntl.nextPageLabel = this.translate.instant('paginatorIntl.next_page');
    this.paginatorIntl.previousPageLabel = this.translate.instant('paginatorIntl.previous_page');
    this.paginatorIntl.firstPageLabel = this.translate.instant('paginatorIntl.first_page');
    this.paginatorIntl.lastPageLabel = this.translate.instant('paginatorIntl.last_page');

    this.paginatorIntl.getRangeLabel = this.getRangeLabel.bind(this);
    this.paginatorIntl.changes.next();
  }
}
